import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { AuthService } from "../auth/auth.service";
import { environment } from "../environments/environment";

@Component({
  selector: "logoff",
  templateUrl: "./logoff.component.html",
  styleUrls: ["logoff.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class LogoffComponent implements OnInit {
  constructor(private authService: AuthService) {}
  ngOnInit(): void {
    if (environment.debug_mode) {
      console.log("Clicked on Logout button.");
    }
    this.authService.logout();
  }
}
